export default __webpack_public_path__ + "static/media/placeholder-large.ed676656.png";